import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

const slides = [
  {
    bg: 'from-orange-500 to-pink-500',
    badge: '🎉 Limited Time Offer',
    title: '0% Commission for First 30 Days',
    desc: 'Start selling today and keep 100% of your earnings for the first month.',
    cta: 'Apply Now',
    emoji: '💰',
  },
  {
    bg: 'from-purple-600 to-indigo-600',
    badge: '🚀 New Sellers',
    title: 'Free Shipping for 90 Days',
    desc: 'We cover your shipping participation fee so you can focus on growing your store.',
    cta: 'Get Started',
    emoji: '🚚',
  },
  {
    bg: 'from-teal-500 to-cyan-600',
    badge: '💳 Bonus Reward',
    title: 'Triple Credit on First Top-Up',
    desc: 'Recharge your seller wallet and get 3x LSS credit bonus instantly.',
    cta: 'Become a Seller',
    emoji: '🪙',
  },
  {
    bg: 'from-rose-500 to-orange-400',
    badge: '📦 Easy Setup',
    title: 'List Products in Minutes',
    desc: 'Our simple product upload tool lets you go live with your store in no time.',
    cta: 'Start Selling',
    emoji: '📦',
  },
];

const HeroBannerSlider = () => {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => setCurrent((c) => (c + 1) % slides.length), []);
  const prev = () => setCurrent((c) => (c - 1 + slides.length) % slides.length);

  useEffect(() => {
    const timer = setInterval(next, 4000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <div className="relative w-full h-[360px] overflow-hidden">
      {slides.map((slide, i) => (
        <div
          key={i}
          className={`absolute inset-0 bg-gradient-to-r ${slide.bg} text-white flex flex-col items-center justify-center text-center px-16 transition-opacity duration-500 ${i === current ? 'opacity-100 z-10' : 'opacity-0 z-0'}`}
        >
          <span className="inline-block bg-white/20 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            {slide.badge}
          </span>
          <div className="text-7xl mb-4 select-none">{slide.emoji}</div>
          <h2 className="text-3xl md:text-4xl font-extrabold leading-tight mb-3 max-w-2xl">{slide.title}</h2>
          <p className="text-white/80 text-base max-w-lg mb-6">{slide.desc}</p>
          <Link
            to="/become-seller"
            className="inline-block px-8 py-3 bg-white text-gray-900 font-bold text-sm rounded-full hover:bg-gray-100 transition-colors no-underline"
          >
            {slide.cta} →
          </Link>
        </div>
      ))}

      {/* Left arrow */}
      <button
        onClick={prev}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 rounded-full bg-white/20 hover:bg-white/35 text-white flex items-center justify-center transition-colors"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      {/* Right arrow */}
      <button
        onClick={next}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 rounded-full bg-white/20 hover:bg-white/35 text-white flex items-center justify-center transition-colors"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>

      {/* Dots */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 flex gap-2">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`h-2 rounded-full transition-all ${i === current ? 'w-8 bg-white' : 'w-2 bg-white/40'}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroBannerSlider;
